//import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { store } from './store/Store';
import App from './App';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, msalInstanceInitialized } from "./msalInstance";
import { initKendoGridAutoSize } from './components/kendoComponents/initKendoGridAutoSize/InitKendoGridAutoSize';


const container = document.getElementById('root');
const root = createRoot(container);

msalInstanceInitialized.then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </MsalProvider>
  );

  initKendoGridAutoSize();

  reportWebVitals();
});

// <React.StrictMode> </React.StrictMode> If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
